module.exports = __webpack_public_path__ + "img/r.7ae63c6b.svg";